<template>
  <div class="service">
    <!--导航栏-->
    <header-nav></header-nav>
    <!--个人中心导航-->
    <user-nav>
      <div class="source-list noSelect" slot="user-nav-let-center">
        <div class="source-item" @click="onSetSource(0)" :class="{'active': source === 0}">
          <span class="iconfont icon-taobao"></span>
          <div class="source-text">淘宝天猫</div>
        </div>
        <div class="source-item" @click="onSetSource(1)" :class="{'active': source === 1}">
          <span class="iconfont icon-jingdong"></span>
          <div class="source-text">京东</div>
        </div>
        <div class="source-item" @click="onSetSource(2)" :class="{'active': source === 2}">
          <span class="iconfont icon-pinduoduo"></span>
          <div class="source-text">拼多多</div>
        </div>
        <div class="source-item" @click="onSetSource(4)" :class="{'active': source === 4}">
          <span class="iconfont icon-douyin"></span>
          <div class="source-text">抖音</div>
        </div>
        <div class="source-item" @click="onSetSource(5)" :class="{'active': source === 5}">
          <span class="iconfont icon-kuaishou"></span>
          <div class="source-text">快手</div>
        </div>
      </div>
    </user-nav>

    <div class="user-center">
      <el-tabs class="border-card-main" type="border-card">
        <el-tab-pane label="收费标准">
          <div class="vip-level-box noSelect">
            <span class="vip-level-name">您的会员等级：</span>
            <div class="vip-level-right">
              <span class="now-vip-level" v-if="user.level_name!='分站加盟'">{{user.level_name}}</span>
              <span class="now-vip-level" v-else>****</span>

              <div class="vip-level-list">
                <div class="vip-level-item"
                     :class="{'active': index === up_index}"
                     v-for="(item, index) in up_level_list"
                     :key="item.id"
                     v-if="user.level_name !== item.level_name"
                     @click="onUpUserLevel(item, index)">
                  <img class="vip-level-icon" :src="IMG_URL+'images/icons/vip.png'" alt="">
                  <div class="up-vip-right">
                    <div class="up-vip-price">充值：<span class="up_price">￥{{item.up_price}}</span></div>
                    <div class="up-vip-level"><span class="">送</span> {{item.level_name}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="express-list">
<!--            <div class="express-item"-->
<!--                 :class="{'express-item-one': (item.delivery_code === 'YTO' || item.delivery_code === 'DSWL'), 'active': item.delivery_name === express_name}"-->
<!--                 v-for="(item, index) in expressData"-->
<!--                 :key="index"-->
<!--                 @click="onSetExpress(item)">-->
<!--              <img class="express-item-icon" :src="'/static/images/express/'+item.delivery_code+'.png'" alt="">-->
<!--            </div>-->
            <el-radio-group v-model="express_name" size="small" @change="onSetExpress">
              <el-radio :label="''" border>全部快递</el-radio>
              <el-radio v-for="(item, index) in expressData" :key="index" :label="item.delivery_name" border>{{item.delivery_name}}</el-radio>
            </el-radio-group>
          </div>

          <div class="price-table">
            <el-table
                :data="depotList"
                v-loading="loadingPrice"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                border
                max-height="500"
                style="width: 100%">
              <el-table-column width="280">
                <template slot-scope="scope">
                  <div class="depot-box">
                    <div class="depot-name">{{scope.row.depot_name | depotFilter}}</div>
                    <img class="depot-icon" v-for="(img, index) in iconFilter(scope.row.depot_name)" :key="index" :src="img" alt="">
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" v-for="(item, index) in levelList" :key="item.id" :label="item.level_name">
                <template slot-scope="scope">
                  <span>{{scope.row.sub[index]}}</span>
                </template>
              </el-table-column>
            </el-table>

            <div class="btn-style up-level-btn" @click="onRecharge" v-if="up_level_list.length > 0">立即充值</div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!--底部-->
    <footer-box></footer-box>



    <div class="pay-meng-main" v-if="dialogVisible">
      <div class="pay-main">
        <i class="close-icon el-icon-error" @click="onClosePay"></i>
        <div v-if="!is_pay_success" class="pay-content">
          <p class="pay-title">请用<span class="zhifubao">支付宝</span>扫描下方二维码充值</p>
          <img class="zfb-code" :src="payCode" alt="">
          <p class="pay-money">扫码充值：{{payMoney}}元</p>
        </div>
        <div v-if="!is_pay_success" class="pay-footer">
          <p class="pay-tips1">无需备注，自动转账</p>
          <p class="pay-tips2">充值成功到账后本页面将出现充值成功提示！</p>
        </div>
        <div class="paySuccess" v-if="is_pay_success">
          <div class="pay-success-top">
            <i class="el-icon-success"></i>
            <div class="pay-success-title">充值成功</div>
            <p class="pay-tips">充值记录可以在充值记录查看</p>
            <p class="pay-tips">土豪，可以去下单啦！</p>
          </div>

          <div class="button-box">
            <a href="javascript:void(0)" class="btn btn2" @click="onPayOk(0)">关 闭</a>
            <a href="javascript:void(0)" class="btn btn1" @click="onPayOk(1)">去下单</a>
          </div>
        </div>
      </div>
    </div>

    <loading ref="loading"></loading>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index"
import userNav from "@/components/userNav/index"
import footerBox from "@/components/footerBox/index"
import {apiUserLevelLst, apiExpressGet, apiUserLevelNewDepot, apiWalletCheckPay, apiWalletOnLinePut} from "@/api/api"

export default {
  name: "service",
  components:{headerNav, userNav, footerBox},
  data(){
    return{
      loadingPrice: false,
      dialogVisible: false,
      is_pay_success: false,
      money: 0,
      payMoney: 0,
      source: 0,
      express_name: "",
      expressData: [],
      param: {
        page: 1,
        limit: 12,
      },
      total: 0,
      e_index: 1,
      levelList: [],
      up_index: 0,
      up_level_list: [],
      depotList: [],
      closeTime: null
    }
  },
  filters: {
    depotFilter(value){
      var name = value.split("*");
      return name[0];
    }
  },
  computed:{
    user(){
      return this.$store.getters.user_info;
    }
  },
  mounted(){
    this.getLevelList();
    this.getDepotList();
    this.expressGet();
  },
  methods: {
    iconFilter(name){
      var list = [];
      if(name.indexOf("淘宝") !== -1){
        list.push(this.IMG_URL+"/images/order/tb-icon.png");
      }
      if(name.indexOf("京东") !== -1){
        list.push(this.IMG_URL+"/images/order/jd-icon.png");
      }
      if(name.indexOf("拼多多") !== -1){
        list.push(this.IMG_URL+"/images/order/pdd-icon.png");
      }
      if(name.indexOf("抖音") !== -1){
        list.push(this.IMG_URL+"/images/order/dy-icon.png");
      }
      if(name.indexOf("快手") !== -1){
        list.push(this.IMG_URL+"/images/order/ks-icon.png");
      }
      return list;
    },
    onPayOk(type){
      if(type === 1){
        this.$router.push("/order/add")
      }else{
        this.dialogVisible = false;
        this.is_pay_success = false;
      }
    },
    // 我已支付|稍后操作
    onClosePay() {
      this.dialogVisible = false
    },
    // 充值
    onRecharge() {
      this.$refs.loading.open();
      this.dialogVisible = false
      apiWalletOnLinePut({
        money: this.money,
        type: 'qr'
      }).then(res => {
        if (res.code === 1) {
          this.$refs.loading.close();
          if(typeof(res.data.paytotal) != "undefined"){
            this.payMoney = res.data.paytotal;
          }

          this.$confirm('为避免延迟到账或不到账，请务必准确支付<strong class="payMoney">'+this.payMoney+"</strong>元,最终到账金额<strong class='payMoney'>"+this.payMoney+"</strong>元！", '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            dangerouslyUseHTMLString: true
          }).then(() => {
            this.payCode = this.API_URL + 'api/wallet/getQrcode.html?text=' + res.data.url+'&orderid='+res.data.orderid+'&paytotal='+res.data.paytotal;
            this.dialogVisible = true;
            this.closeTime = setInterval(() => {
              apiWalletCheckPay({ orderid: res.data.orderid }).then(res => {
                if (res.code === 1) {
                  this.is_pay_success = true;
                  this.$store.dispatch('GetUserInfo');
                  clearInterval(this.closeTime);
                }
              })
            }, 2000)
          }).catch(() => {
          });
        }else{
          this.$refs.loading.close();
          this.$message.info(res.msg);
        }
      })
    },

    onUpUserLevel(row, index){
      this.up_index = index;
      this.money = row.up_price;
    },
    onSetExpress(row){
      this.getDepotList();
    },
    onSetSource(source){
      this.source = source;
      this.getDepotList();
    },
    getLevelList(){
      apiUserLevelLst().then(res =>{
        if(res.code === 1){
          // this.levelList = res.data;
          console.log("res.data",res.data);
          var lsLevelList = [];
          for(var i = 0; i < res.data.length; i++){
            if(res.data[i].level_name=="分站加盟"){
              continue;
            }
            lsLevelList.push(res.data[i]);

            if(this.user.level_name === res.data[i].level_name){
              for(var k = 0; k < res.data.length; k++) {
                if(k > i && res.data[k].level_name!="分站加盟"){
                  this.up_level_list.push(res.data[k]);
                }
              }
            }
          }
          this.levelList = lsLevelList;
          if(this.up_level_list.length > 0){
            this.money = this.up_level_list[0].up_price;
          }
        }
      })
    },
    //获取快递列表
    expressGet() {
      apiExpressGet().then(res => {
        this.expressData = res.data.rows;
        this.getDepotList();
      })
    },
    getDepotList(){
      this.loadingPrice = true;
      apiUserLevelNewDepot({source: this.source, delivery_name: this.express_name}).then(res => {
        if(res.code === 1){
          this.loadingPrice = false;
          this.depotList = res.data
        }
      })
    }
  }
}
</script>


<style>
.payMoney{
  color: red;
  font-size: 20px;
}
.el-tabs--border-card{
  border: none;
  box-shadow: none;
}
.el-tabs__item{
  padding: 0 60px !important;
}
.el-table td, .el-table th.is-leaf{
  /*height: 30px;*/
  /*line-height: 30px;*/
  padding: 5px 0;
}
.el-table th {
  background-color: #0f375a;
  color: #ffffff;
  font-size: 14px;
  border: none;
  font-weight: 400;
}
.el-table td {
  color: #000000;
  font-size: 14px;
}
.el-radio{
  margin-right: 20px;
}
</style>
<style scoped lang="scss">
.service{
  min-height: 100vh;
  position: relative;
  padding-bottom: 80px;
  background-color: #eeeeee;

  .source-list{
    margin-top: 10px;

    .source-item{
      width: 160px;
      height: 60px;
      margin-bottom: 10px;
      background-color: #ffffff;
      display: flex;
      align-items: center;
      padding: 0 35px;
      cursor: pointer;

      .iconfont{
        margin-right: 10px;
        color: #000000;
        font-size: 22px;
      }
      .source-text{
        font-size: 14px;
        color: #000000;
        font-weight: 400;
      }

      &.active{
        background-color: #FF0000;

        .iconfont{
          color: #ffffff;
        }
        .source-text{
          color: #ffffff;
        }

      }
    }
  }


  .user-center{
    width: 1300px;
    margin: 0 auto;
    padding-left: 180px;

    .border-card-main{
      min-height: calc(100vh - 270px);
    }
    .vip-level-box{
      margin: 40px 0;
      display: flex;
      align-items: center;

      .vip-level-name{
        color: #000000;
        font-size: 14px;
      }

      .vip-level-right{
        display: flex;
        align-items: center;

        .now-vip-level{
          font-weight: bold;
          color: #0f375a;
          font-size: 16px;
        }

        .vip-level-list{
          display: flex;
          align-items: center;
          margin-left: 20px;

          .vip-level-item{
            height: 50px;
            border-radius: 5px;
            border: 2px solid #E6E6E6;
            padding: 0 15px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            color: #0f375a;
            font-weight: 400;
            margin-right: 20px;
            cursor: pointer;

            .vip-level-icon{
              height: 32px;
              margin-right: 6px;
            }
            .up-vip-right{

              .up-vip-price{

                .up_price{
                  font-size: 14px;
                  font-weight: bold;
                  color: #ff4b2b;
                }
              }
            }
            .up-vip-level{
              font-weight: bold;
            }
            
            &.active{
              border: 2px solid #0f375a;
            }
          }
        }
      }

    }

    .depot-box{
      display: flex;
      align-items: center;

      .depot-name{
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2;
        overflow:hidden;
      }

      .depot-icon{
        width:18px;
        height: 18px;
        border-radius: 50%;
        margin-right: 5px;

      }
    }

    .express-list{
      margin-bottom: 30px;

      .express-item{
        width: 135px;
        margin-bottom: 10px;
        margin-right: 20px;
        border: 1px solid #eeeeee;
        border-radius: 5px;

        height: 70px;
        box-sizing: border-box;
        cursor: pointer;
        overflow: hidden;

        .express-item-icon{
          height: 70px;
          display: block;
          width: auto;
        }

        &.active{
          border: 1px solid #0f375a;
        }
      }

      .express-item-one{
        width: 135px;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #eeeeee;
        border-radius: 4px;

        .express-item-icon{
          height: 46px;
          width: auto;
        }
      }
    }

    .up-level-btn{
      margin-top: 20px;
    }
  }

  .pay-meng-main {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1000;

    .pay-main {
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      border-radius: 10px;
      width: 320px;
      height: 370px;
      background-color: #0f375a;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 20px;

      .close-icon {
        font-size: 30px;
        color: #ffffff;
        position: absolute;
        right: -10px;
        top: -10px;
        cursor: pointer;
      }

      .pay-content {
        width: 280px;
        height: 280px;
        background-color: #ffffff;
        border-radius: 10px 10px 0 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;

        .zfb-code {
          width: 180px;
          height: 180px;
        }

        .pay-title {
          font-size: 14px;
          color: #000000;

          .zhifubao {
            color: #0f375a;
          }
        }

        .pay-money {
          font-size: 20px;
          font-weight: bold;
          color: #ff0000;
        }
      }

      .pay-footer {
        p {
          margin: 0;
          font-size: 12px;
          text-align: center;
          color: #ffffff;
          margin-top: 5px;
        }

        .pay-tips2 {
          font-weight: bolder;
        }
      }

      .paySuccess{
        background-color: #ffffff;
        width: 100%;
        height: 100%;
        border-radius: 10px 10px 0 0 ;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        padding: 30px 20px 20px;

        .pay-success-top{
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          p{margin: 0;color: #000000;}

          .el-icon-success{
            font-size: 88px;
            color: #0f375a;
          }
          .pay-success-title{
            font-weight: bold;
            color: #000;
            font-size: 28px;
            margin: 15px 0;
          }

        }

        .button-box{
          display: flex;
          align-items: center;

          .btn{
            width: 100px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #979797;
            margin: 0 10px;
            color: #979797;
          }
          .btn1{color: #0f375a;}
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/service/index.vue